import { Seo } from "../lib/seo";

export const LegalPlaceholder = ({ title, path, kind }) => (
  <>
    <Seo title={title} description={`Bancony ${title.toLowerCase()}.`} path={path} noindex />
    <div className="legal-shell">
      <span className="section-eyebrow">Legal</span>
      <h1>{title}</h1>
      <p>
        These {kind} are being finalised by Bancony's legal counsel. The current draft is
        available on request. Email{" "}
        <a href="mailto:legal@bancony.com">legal@bancony.com</a> and we will send it the
        same working day.
      </p>
      <p>
        Once the text is approved, it will appear here in full. We will not back-date it;
        the date of publication on this page is the date the document becomes effective.
      </p>
    </div>
  </>
);
